import OBTPopupPanel from './OBTPopupPanel';
export default OBTPopupPanel;
